import { useRiskRegisterStore } from 'store/riskRegister.store';

import { useQueryGetDistributionGraph } from 'api/queries/getDistributionGraph.query';
import { useQueryGetSummaryKpi } from 'api/queries/getSummaryKpi.query';

export const useDistributionGraphProvider = ({ latestVersionId }) => {
    const { numOfIterations, riskIds, taskVersionHashCode, period, runQsra } = useRiskRegisterStore();

    return {
        api: {
            getDistributionGraph: useQueryGetDistributionGraph({
                runQsra,
                metaDataId: latestVersionId,
                numOfIterations: numOfIterations,
                riskIds: riskIds,
                taskVersionHashCode: taskVersionHashCode,
                period: period,
            }),
            getSummaryKpi: useQueryGetSummaryKpi({
                runQsra,
                metaDataId: latestVersionId,
                numOfIterations: numOfIterations,
                riskIds: riskIds,
                taskVersionHashCode: taskVersionHashCode,
                period: period,
            }),
        },
    };
};
